import React, { FormEvent, useState } from "react";
import styled from "styled-components";
//**  Need to import filter form css file here
import "../static/css/components/FilterForm.css";

interface IFilterFormProps {
  handleFormChange: (e: FormEvent) => void;
}
const FilterList = styled.div`
  & {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    margin: 0.2rem 0 0 0;
  }
  &::-webkit-scrollbar {
    display: none;
  }
`;
export const FilterForm: React.FunctionComponent<any> = (props) => {
  // This is the function that changes the color of the input label everytime a user checks an element **Also changes it back**
  const handleCheck = (e: any) => {
    // Setting the purple color
    const purpleColor = "#522398";
    // RGB version of the purple color
    const rgbPurpleColor = "rgb(82, 35, 152)";
    // CSS Style for BOLD Font Weight
    const boldFontWeight = 700;
    // CSS Style for normal font weight
    const normalFontWeight = "normal";
    // Getting the parent element based on the input the user just clicked on !** The parent element should be the label tag**
    let parentElement = e.target.parentNode;
    // ** Getting the styles for the parent element
    const parentElementStyles = parentElement.style;

    // If the parent element color is purple....
    if (parentElementStyles.color == rgbPurpleColor) {
      // Make the color go back to black
      parentElementStyles.color = "black";
      // Make the font weight return back to normal
      parentElementStyles.fontWeight = normalFontWeight;
    } else {
      // Else, make the element color purple
      parentElementStyles.color = purpleColor;
      // And, make the font weight bold
      parentElementStyles.fontWeight = boldFontWeight;
    }
  };

  const [size, setSize] = useState(
    window.innerWidth <= 770 ? "mobile" : "desktop"
  );

  return (
    <FilterList>
      <form>{props.children}</form>
    </FilterList>
  );
};
//onChange={(e) => props.handleFormChange(e)} method="GET" action=""

export default FilterForm;
